import { connect } from 'react-redux';
import { flowRight, pick } from 'lodash';
import TelehealthResult from './TelehealthResult';
import { getSearchParameters } from '../../../../state/parameters/index.js';
import { shouldLinkTelehealthProfile } from '../../../../../config/ab/selector';
import { TELEHEALTH_LINK_TO_PROFILE } from '../../../../../config/ab/experiments';
import withAB from '../../../../../config/ab/withAB';

import {
    trackAdClick,
    trackModalDownloadClick,
    trackModalSendSmsClick,
    trackModalClose,
    trackModalPhoneNumberInput,
    trackAdView,
    trackModalSendSmsFailureView,
    trackModalSendSmsSuccessView,
} from '../../../../../Shared/Telehealth/eventTrackingActions';

const getQueryParamsFromProps = props => {
    const {
        adDecisionId,
        decisionToken,
        provider: {
            allowedPatient,
            coupon,
        },
    } = props.adData;

    const queryParams = {
        ad_decision_id: adDecisionId,
        allowed_patient: allowedPatient,
        decision_token: decisionToken,
        specialty_id: props.specialtyId,
        procedure_id: props.procedureId,
    };

    if (coupon) {
        queryParams.discounted_cost = coupon.discountedCost;
        queryParams.coupon_code = coupon.couponCode;
    }

    return queryParams;
};

const mapStateToProps = (state, ownProps) => {
    const newProps = pick(getSearchParameters(state), ['specialtyId', 'procedureId']);
    newProps.shouldLinkToProfile = shouldLinkTelehealthProfile(state);
    newProps.queryParams = getQueryParamsFromProps({
        ...ownProps,
        ...newProps,
    });
    return newProps;
};

const mapDispatchToProps = {
    onChangePhoneNumberInput: trackModalPhoneNumberInput,
    onClickAd: trackAdClick,
    onClickCloseModal: trackModalClose,
    onClickDownload: trackModalDownloadClick,
    onClickSendSms: trackModalSendSmsClick,
    onViewAd: trackAdView,
    onViewSendSmsFailure: trackModalSendSmsFailureView,
    onViewSendSmsSuccess: trackModalSendSmsSuccessView,
};

export default flowRight(
    withAB(TELEHEALTH_LINK_TO_PROFILE),
    connect(mapStateToProps, mapDispatchToProps)
)(TelehealthResult);
